// src/components/common/UserModalContainer/UserModalContainer.tsx
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import AppModal from '@/components/common/AppModal/AppModal';
import { closeModal } from '@/store/slices/ui/uiSlice';
import { useAppDispatch } from '@/store';
import { selectIsEditUserModal } from '@/store/selectors/ui';
import { selectUser } from '@/store/selectors/user';
import { updateMeThunk } from '@/store/thunks/user/updateThunk';
import UserForm from '@/components/common/UserModalContainer/UserForm';

const UserModalContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const isEditUserOpen = useSelector(selectIsEditUserModal);
  const user = useSelector(selectUser);

  const defaultValues = useMemo(() => ({
    name: user?.name ?? '',
    phone: user?.phone ?? '',
    organization: user?.department ?? '',
  }), [user]);

  const handleClose = useCallback(() => dispatch(closeModal()), [dispatch]);

  const handleSubmit = useCallback((values: Record<string, string>) => {
    if (user?.id === undefined) return;
    void dispatch(updateMeThunk({
      id: user.id,
      name: values.name,
      phone: values.phone,
      department: values.organization,
    }))
      .unwrap()
      .then(() => {
        dispatch(closeModal());
      })
  }, [dispatch, user]);

  if (!isEditUserOpen) return null;

  return (
    <AppModal onClose={handleClose} title="Edit your user information" size="md">
      <UserForm defaultValues={defaultValues} onSubmit={handleSubmit} />
    </AppModal>
  );
};

export default UserModalContainer;
